import request from '@/config/axios'

export const getIndustryMappingPage = (params: any) =>
  request.get({ url: '/bosscircle/industry-mapping/page', params })

export const createIndustryMapping = (data: any) =>
  request.post({ url: '/bosscircle/industry-mapping/create', data })

export const updateIndustryMapping = (data: any) =>
  request.put({ url: '/bosscircle/industry-mapping/update', data })

export const deleteIndustryMapping = (id: number) =>
  request.delete({ url: '/bosscircle/industry-mapping/delete', params: { id } })
